// A mock function to mimic making an async request for data
import { IUser } from "definitions/app/user";
import { handleErrorResp, httpClient } from "../../../Service/Service";


export async function searchUsers() {
  try {
    return await httpClient<any>(`user/getall`, "GET", {});
  } catch (err) {
    return handleErrorResp(err);
  }
}
export async function addAUser(data: IUser) {
  try {
    return await httpClient<any>(`user/add`, "POST", data);
  } catch (err) {
    return handleErrorResp(err);
  }
}
export async function updateAUser(data: IUser) {
  try {
    return await httpClient<any>(`user/${data._id}`, "PATCH", data);
  } catch (err) {
    return handleErrorResp(err);
  }
}

export const updateUserRole = async (email: string, role: string) => {
  try {
    const result = await httpClient("user/roleupdate", "POST", {
      "email": email,
      "role": role
    });
    return result
  } catch (error) {
    console.error("Error updating user role:", error);
    throw error;
  }
};

export const blockUser = async (email: string) => {
  try {
    const result = await httpClient("user/block", "POST", { "email": email });
    return result.data;
  } catch (error) {
    console.error("Error blocking user:", error);
    throw error;
  }
};

